






























import {
	computed,
	defineComponent,
	ref,
	watch,
} from '@vue/composition-api';
import LoaderState from '@front-app/components/LoaderState.vue';
import LoginForm from '@front-app/components/forms/LoginForm.vue';
import PublicAuthPage from '@front-app/components/layouts/PublicAuthPage.vue';
import PublicGroupCard from '@front-app/components/cards/PublicGroupCard.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import { getPublicGroup } from '@front-app/services/GroupsApi/GroupsApi';
import { GroupsLogoStore } from '@front-app/store/singletons/Groups';
import { PublicGroupData } from '@front-app/services/GroupsApi/GroupModel';
import { Routes } from '@front-app/constants/routes';
import { Spacing } from '@front-app/components/constants';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';

export default defineComponent({
	components: {
		LoaderState,
		LoginForm,
		PublicAuthPage,
		PublicGroupCard,
		SimpleCard,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		redirectPath: {
			type: String,
			default: '',
		},
	},
	setup(props, ctx) {
		// Group preview
		const group = ref(null as null | PublicGroupData);

		const {
			track: trackFetchingPublicGroup,
			isLoading: isFetchingPublicGroup,
			isSuccess: isSuccessFetchingPublicGroup,
		} = useAsyncStatus();
		const {
			track: trackFetchingPublicGroupLogo,
			isLoading: isFetchingPublicGroupLogo,
		} = useAsyncStatus();
		watch(() => props.groupId, async () => {
			await trackFetchingPublicGroupLogo(GroupsLogoStore.fetch(props.groupId));
			const result = await trackFetchingPublicGroup(getPublicGroup(props.groupId));
			if (isSuccessFetchingPublicGroup) {
				group.value = result;
			}
		}, { immediate: true });

		const isGroupPublic = computed(() => {
			if (group.value	&& group.value?.isPublic) {
				return true;
			}
			return false;
		});
		// END Group preview

		// Logging in
		const redirect = () => {
			if (props.redirectPath) {
				ctx.root.$router.push(props.redirectPath);
			} else {
				ctx.root.$router.push({
					name: Routes.GROUP_MAIN,
					params: { groupId: props.groupId },
				});
			}
		};
		// END Logging in

		return {
			// Group preview
			isFetchingPublicGroup,
			isFetchingPublicGroupLogo,
			isGroupPublic,
			group,
			// Logging in
			redirect,
			// Util
			Spacing,
		};
	},
});
